import { ReactComponent as Polkadot } from "../../../components/icons/polkadot.svg";
import { polkadotColor } from "./common";

const ipxdemo = {
  name: "ipxchange Demo",
  icon: <Polkadot />,
  identity: "ipxdemo",
  sub: "ipxdemo",
  value: "ipxdemo",
  chain: "ipxdemo",
  symbol: "GSX",
  decimals: 18,
  chainIcon: "originalGen6",
  ...polkadotColor,
  buttonColor: "#E6007A",
  logo: "logo-img-2",
  modules: {
    treasury: false,
    governance: false,
    identity: false,
    multisig: false,
    vestings: false,
    proxy: false,
  },
  nodes: [
    { name: "ipxchange demo explorer", url: "wss://explorer-demo.ipxchange.io/node"},
    // { name: "Gen6 app", url: "wss://gen6.dev/node"},
    // { name: "localhost", url: "ws://127.0.0.1:9944" },
  ],
  useOnChainBlockData: true,
};

export default ipxdemo;
